export const getTimeFromIsoDate = (isoDate: string): string => {
  try {
    const date = isoDate.split('T').pop();

    return date;
  } catch (err) {
    return '';
  }
};
